































import { computed, defineComponent, PropType, ref } from "@vue/composition-api";
import { Participant, ParticipantStatus } from "@scrile/api-provider/dist/api/ParticipantProvider";
import { $t } from "@/lib/i18nHelpers";
import AvatarsGroup from "@/components/AvatarsGroup";
import BaseButton from "@/components/BaseButton";
import BaseIconButton from "@/components/BaseIconButton";
import ModalParticipantsManage from "./ModalParticipantsManage.vue";

const STATUS_LABELS: Record<ParticipantStatus, string> = {
  [ParticipantStatus.NEW]: $t("pending"),
  [ParticipantStatus.ACCEPTED]: $t("accepted"),
  [ParticipantStatus.REJECTED]: $t("rejected"),
};

const STATUS_ORDER: ParticipantStatus[] = [
  ParticipantStatus.NEW,
  ParticipantStatus.ACCEPTED,
  ParticipantStatus.REJECTED,
];

export default defineComponent({
  name: "Participants",
  components: {
    AvatarsGroup,
    BaseButton,
    BaseIconButton,
    ModalParticipantsManage,
  },
  props: {
    // Controlled by PostCreate via usePostParticipants so the state survives the editor being
    // minimized/unmounted while files upload.
    participants: { type: Array as PropType<Participant[]>, default: () => [] },
    isDraft: { type: Boolean, default: false },
  },
  setup(props, { emit }) {
    const showModal = ref(false);

    const displayedUsers = computed(() => props.participants.map(p => p.user));

    const statusSummary = computed(() => {
      const counts: Record<string, number> = {};
      for (const p of props.participants) {
        counts[p.status] = (counts[p.status] || 0) + 1;
      }
      return STATUS_ORDER.filter(status => counts[status])
        .map(status => `${counts[status]} ${STATUS_LABELS[status]}`)
        .join(", ");
    });

    const onModalConfirm = (updatedList: Participant[]) => {
      emit("participantsChange", updatedList);
      showModal.value = false;
    };

    const onParticipantResend = (participant: Participant) => {
      emit("participantResend", participant);
    };

    return {
      showModal,
      displayedUsers,
      statusSummary,
      onModalConfirm,
      onParticipantResend,
    };
  },
});
